<template>
  <v-data-table
    :headers="headers"
    :items="activitiesFilter"
    :page.sync="pagination.page"
    :items-per-page.sync="paginationActivitiesTable.rowsPerPage"
    :items-per-page-text="$t('tables.RowsPerPage')"
    :header-props="{ sortIcon: 'mdi-menu-down' }"
    :footer-props="{ prevIcon: 'mdi-menu-left', nextIcon: 'mdi-menu-right', 'items-per-page-options': rowsPerPageItems}"
    :loading="loading"
    loading-text=""
    class="mt-3 mb-2 elevation-2"
     @pagination="setRowsOnLocalStorage(dataTableActivitiesTableId,paginationActivitiesTable.rowsPerPage)"
  >
    <template v-slot:item="props">
      <tr @click="openActivity(props.item)">
        <td>
          <activity-task-status-icon
            :status="props.item.state"
            :delayed="isDelayed(props.item)"
          />
        </td>

        <!--<td>{{ showDependencies(props.item) }}</td>-->

        <td>{{ props.item.title }}</td>

        <td>
          <v-layout row align-center>
            <v-icon
              v-if="getCreatorType(props.item.user_creator_id) !== ''"
              small
              color="accent"
              class="mr-1"
            >
              {{ getCreatorType(props.item.user_creator_id) }}
            </v-icon>

            <span>{{ getUserName(props.item.user_creator_id) }}</span>
          </v-layout>
        </td>

        <td>
          {{ getFormattedDate(props.item.due_date) }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import ActivityTaskStatusIcon from "../../../../FieldManagement/StatusIcon";
import { mapActions } from "vuex";
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
export default {
  name: "ObjectFormActivitiesTable",

  components: { ActivityTaskStatusIcon },

  mixins: [activitiesTasksDataMixin,managementDatatableMixin],

  props: {
    mode: {
      type: String
    },

    objectUuid: String,
    objectLayer: String
  },

  data() {
    return {
      activities: [],
      loading: false,
      dataTableActivitiesTableId: "dataTableActivitiesTableId" ,
      paginationActivitiesTable: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableActivitiesTableId")
      },
      pagination: {
        sortBy: "title"
      }
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$i18n.t("State"),
          value: "state",
          width: "10%"
        },
        /*{
          text: this.$i18n.tc("Dependency", 2),
          value: "dependencies",
          width: "10%"
        },*/
        { text: this.$i18n.tc("Activity", 1), value: "title", width: "50%" },
        {
          text: this.$i18n.t("Creator"),
          value: "user_creator_id",
          width: "15%"
        },
        { text: this.$i18n.t("DueDate"), value: "due_date", width: "15%" }
      ];
    },

    activitiesFilter() {
      if (this.mode === "history") {
        return this.activities.filter(item => item.state === "completed");
      }
      return this.activities;
    }
  },

  created() {
    this.loadAllUsers();
  },

  mounted() {
    if (this.objectUuid && this.objectLayer) {
      this.getObjectActivities();
    }
  },

  methods: {
    ...mapActions(["fetchObjectActivities"]),

    async getObjectActivities() {
      try {
        this.loading = true;
        this.activities = await this.fetchObjectActivities({
          filters: [
            {
              field: "object_uuid",
              value: this.objectUuid
            },
            {
              field: "object_type",
              value: this.objectLayer
            }
          ]
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    openActivity(activity) {
      this.$emit("openActivity", activity.uuid);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/ActivitiesTable.vue